import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function WeekChampionIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3824">
      
      <div className="relative w-full h-full bg-gradient-to-b from-indigo-900 to-purple-900 overflow-hidden" data-id="element-3825">
        {/* Background: Spotlight and Stars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3826">
          
          {/* Spotlight */}
          <path d="M100 0 L180 200 L20 200 Z" fill="url(#spotlight-grad)" opacity="0.4" data-id="element-3827" />
          
          {/* Stars */}
          <circle cx="40" cy="50" r="2" fill="#FDE047" data-id="element-3828" />
          <circle cx="160" cy="70" r="3" fill="#FDE047" data-id="element-3829" />
          <circle cx="150" cy="30" r="1.5" fill="#FDE047" data-id="element-3830" />
          <circle cx="60" cy="120" r="2" fill="#FDE047" data-id="element-3831" />
          <circle cx="140" cy="140" r="1.5" fill="#FDE047" data-id="element-3832" />

          <defs data-id="element-3833">
            <linearGradient id="spotlight-grad" x1="100" y1="0" x2="100" y2="200" gradientUnits="userSpaceOnUse" data-id="element-3834">
              
              <stop offset="0%" stopColor="#FDE047" stopOpacity="0.8" data-id="element-3835" />
              <stop offset="100%" stopColor="#FDE047" stopOpacity="0" data-id="element-3836" />
            </linearGradient>
          </defs>
        </svg>

        {/* Background: Podium */}
        <svg className="absolute bottom-0 left-0 w-full h-1/3 z-0" viewBox="0 0 200 66" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3837">
          
          <path d="M40 30 L160 30 L180 66 L20 66 Z" fill="#475569" data-id="element-3838" />
          <path d="M40 30 L160 30 L160 35 L40 35 Z" fill="#94A3B8" data-id="element-3839" />
          <path d="M60 45 L140 45 L145 66 L55 66 Z" fill="#334155" data-id="element-3840" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[15%]" data-id="element-3841">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3842">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} variant={variant} accessory="trophy" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3843" />
            
          </div>
        </div>

        {/* Foreground: Confetti */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3844">
          
            <rect x="30" y="80" width="6" height="12" fill="#EF4444" transform="rotate(45 30 80)" data-id="element-3845" />
          
            <rect x="170" y="100" width="8" height="8" fill="#3B82F6" transform="rotate(15 170 100)" data-id="element-3846" />
          
            <rect x="50" y="140" width="10" height="6" fill="#10B981" transform="rotate(-20 50 140)" data-id="element-3847" />
          
            <rect x="150" y="160" width="6" height="10" fill="#F59E0B" transform="rotate(60 150 160)" data-id="element-3848" />
          
          </svg>}
      </div>
    </DjayIllustrationBase>;
}